import React from 'react';
import { FormGroup, Button, ControlLabel, HelpBlock } from 'react-bootstrap';
import update from 'immutability-helper';

import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';

import Select from 'react-select';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';
import Stars from '../../../components/Stars/Stars';

const marks = {1:1,2:2,3:3,4:4,5:5}
const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);


class SearchHotelPrefsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      brands: this.props.savedPrefs.brands,
      stars: this.props.savedPrefs.stars,
      values: {lower: 0, upper: 0},
      save: false,
      brandGroupsList: [],
      isStarChanged: false
    };
    if (this.props.savedPrefs.stars) {
      this.state = {
        brands: this.props.savedPrefs.brands,
        stars: this.props.savedPrefs.stars,
        values: {lower: 0, upper: 0},
        save: false,
        isStarChanged: false
      };
    } else {
      this.state = {
        brands: this.props.savedPrefs.brands,
        stars: { lower: 0, upper: 0 },
        values: {lower: 0, upper: 0},
        save: false,
        isStarChanged: false
      };
    }

    this.handleStarsChange = this.handleStarsChange.bind(this);
    this.clearStarFilter = this.clearStarFilter.bind(this);
    this.handleBrandChange = this.handleBrandChange.bind(this);
    this.brandsByParentBrandGroup = this.brandsByParentBrandGroup.bind(this);
    this.savePreferences = this.savePreferences.bind(this);
  }
  componentDidMount(){
    let lowerValue = 0;
    let upperValue = 5;
    if(this.props.savedPrefs.stars && !this.props.savedPrefs.stars.empty){
      lowerValue = this.props.savedPrefs.stars.lower;
      upperValue = this.props.savedPrefs.stars.upper > 0 ? this.props.savedPrefs.stars.upper - 1 : this.props.savedPrefs.stars.upper;
    }
    this.setState({
      values : {lower: lowerValue, upper: upperValue }
    })
  }
  componentWillReceiveProps(nextProps){
    let brandGroups = [];
    if(nextProps.brandGroups.length){
      nextProps.brandGroups.forEach((brandGroup)=>{
        brandGroups.push(<span>&nbsp;
          <a onClick={() => {
                  this.quickAdd(brandGroup.id);
                }}>
          {brandGroup.brand_group_name}
          </a>,</span>
        )       
      })
      if(brandGroups.length > 1) {
        let lastBrandGroup = brandGroups.pop();
        brandGroups.push(<span> or</span>);
        brandGroups.push(lastBrandGroup);
      }
    }

    this.setState({
      brandGroupsList: brandGroups
    })
  }

  clearStarFilter(){
    this.setState({
      stars: { lower: 0, upper: 5, bounds: '[)' },
      values: { lower: 0, upper: 5 },
      isStarChanged: true,
      save: true
    })
  }

  handleStarsChange(value) {
    this.setState({
      // stars: { lower: value.lower, upper: value.upper, bounds: '[)' },
      stars: { lower: value[0], upper: value[1], bounds: '[)' },
      save: true,
      isStarChanged: true,
      values: {lower: value[0], upper: value[1]}
    });
  }

  brandsByParentBrandGroup(brandId){
    let brandGroup = this.props.brandGroups.filter((bg)=>{
      return bg.id == brandId;
    })
    if(brandGroup.length){
      return brandGroup[0].brands;
    }
    return [];
  }

  handleBrandChange(brands) {
    //debugger
    const brandIds = brands.map(brand => brand.value);
    this.setState({
      brands: brandIds,
      save: true,
    });
  }

  quickAdd(brandId) {
    const brands = update(this.state.brands, { $push: this.brandsByParentBrandGroup(brandId) });
    this.setState({
      brands,
      save: true,
    });
  }
  
  savePreferences(e) {
    e.preventDefault();
    const pref = {
      brands: this.state.brands,
      stars: this.state.stars,
      has_search_prefs: true,
    };
    if(this.state.isStarChanged) {
      pref.stars.upper = pref.stars.upper > 0 && pref.stars.upper < 6 ? pref.stars.upper + 1 : pref.stars.upper;
      this.setState({
        isStarChanged: false
      })
    }
    this.props.saveSearchPrefs(pref)
    this.setState({
      save: false,
    });
    this.props.onClose();
  }

  render() {
    const showDistance = true;
    return (
      <div>
       <div className="spacing brand-picker">
          <FormGroup controlId="brands">
            <ControlLabel>Brands</ControlLabel>
            <Select
              name="brand"
              value={this.state.brands}
              options={this.props.brandList}
              onChange={this.handleBrandChange}
              multi
              joinValues
            />
            <HelpBlock>
              Select hotel brands.
              <br />Quickly add hotels by family of brand
              {this.state.brandGroupsList}
              </HelpBlock>
          </FormGroup>
          <FormGroup controlId="stars">
            <ControlLabel>Hotel Rating</ControlLabel>
            {this.state.stars.lower !== null && !(!this.state.stars.lower && this.state.values.upper == 5) && (
              <p>
                Search includes hotels between {this.state.values.lower} and{' '}
                {this.state.values.upper } stars.
              </p>
            )}
            {!this.state.stars.lower && this.state.values.upper == 5 && <p>Star filter is cleared.</p>}
            <Range min={0} max={5} value={[this.state.values.lower, this.state.values.upper]} defaultValue={[this.state.stars.lower, this.state.stars.upper]} step={1} marks={marks} onChange={this.handleStarsChange} />
            <Button onClick={this.clearStarFilter} className="star-rating-filter-clear-btn">
               ❌ Clear
            </Button>
            <HelpBlock>Filter hotels based on their AAA rating.</HelpBlock>
          </FormGroup>
          {this.state.save && (
          <div className="spacing info-panel">
            <Button onClick={this.savePreferences} bsStyle="primary">
              <i className="fa fa-floppy-o" /> Apply
            </Button>
          </div>
        )}
        </div>
      </div>
    );
  }
}

SearchHotelPrefsForm.propTypes = {
};

SearchHotelPrefsForm.defaultProps = {
};

export default SearchHotelPrefsForm;



// WEBPACK FOOTER //
// src/routes/hotels/components/SearchHotelPrefsForm.js